export enum TaskAssignedUserType
{
    CMR, 
    TMS,
    FSS
}
export const TaskAssignedUserTypeStrs=["CMR","TMS","FSS"]

export const TaskAssignedUserTypeConsumer=["CMR","FSS"]